import React, { Component } from 'react'

import DecoupledLinesChartContainer from 'modules/Charts/DecoupledLines/DecoupledLinesChartContainer'

import API from 'utils/api/api'
import IndicatorTools from 'utils/indicators/indicatorTools'
import RegionTools from 'utils/regions/regionTools'

import Loading from 'components/Loading'
import Error from 'components/Error'


class IndicatorEvolutionContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      layer: 1,
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll')
    this.loadData();
    // let url = this.props.history.location.pathname;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedRegionId !== prevProps.selectedRegionId) {
      this.loadData();
    }
  }

  loadData() {
    if (this.props.selectedRegionId === null) return
    
    // let indicatorId = Number( this.props.match.params.indicatorId );

    // console.log(indicatorId);

    let promises = [];
    const regionsMetaPromise = API.getRegions().then(regions => RegionTools.getDataFromRegions(regions));
    const countriesMetaPromise = API.getCountries().then(countries => RegionTools.getDataFromCountries(countries));
    // const dataPromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorData({ indicator: indicatorId, geo: [1], meta: true })));
    promises.push(regionsMetaPromise);
    promises.push(countriesMetaPromise);
		// promises.push(dataPromise);
    // const p1 = API.getRegions().then(regions => RegionTools.getDataFromRegions(regions))
    const indicatorsMetaPromise = API.getIndicators().then(indicators => IndicatorTools.getDataFromIndicators( indicators ))
    promises.push(indicatorsMetaPromise);
    // const p5 = API.getIndicatorsStatus().then(indicatorsStatus => indicatorsStatus.last_checked_on)
    // const p6 = API.getCountries().then(countries => RegionTools.getDataFromCountries(countries))

    Promise.all(promises)
      .then(values => {
        // console.log( this.props );
        this.props.setRegionsData( values[0] );
        this.props.setCountriesData( values[1] );
        this.props.setIndicatorsData( values[2] );

        let selectedRegionMeta = values[0].filter(region => Number(region.id) === Number(this.props.selectedRegionId))[0];

        let selectedRegionCountryMeta = RegionTools.countryCodeToMeta(
          RegionTools.getCountryCodeFromRegionCode( selectedRegionMeta.code )
        );
        this.props.setSelectedRegionCountryMeta(selectedRegionCountryMeta);

        let indicatorData = values[2].filter(item => Number(item.id) === Number(this.props.match.params.indicatorId))[0];
        return indicatorData;
        // console.log("ok")
        // this.props.setIndicatorsData([values[0]["meta"]]);
      })
      .then((indicatorData) => {
        this.setState({ loading: false, error: false, indicatorData: indicatorData });
      })
      .catch(reason => {
        this.setState({ error: true, loading: false })
      })
  }

  renderIfAllOK() {
    let renderingComponent = null
    if (this.state.error) {
      renderingComponent = <Error />
    } else if (this.state.loading) {
      renderingComponent = <Loading />
    } else {
      let indicatorId = Number( this.props.match.params.indicatorId );
      // console.log( this.state.indicatorData );

      renderingComponent = (
        <React.Fragment>
          {/* <h1>{IndicatorTools.cleanIndicatorName(this.state.indicatorData.name)}</h1>
          <p>Fuente: {this.state.indicatorData.dataSource}</p> */}
          <DecoupledLinesChartContainer indicator={indicatorId} 
                                        selectedRegionId={this.props.selectedRegionId}
                                        startingYear={this.props.timePeriodStart}
                                        endingYear={this.props.timePeriodEnd}
                                        numberOfYears={this.props.timePeriodLength}
                                        geoIds={this.props.geoIds}
                                        regionsToPlot={this.props.regionsToPlot}
                                        embed={this.props.embed}/>
        </React.Fragment>
      )
    }
    return renderingComponent
  }

  render() {
    // return <div className="container-fluid ork-gray-box">{this.renderIfAllOK()}</div>
    return this.renderIfAllOK();
  }
}

IndicatorEvolutionContainer.defaultProps = {
  timePeriodStart:  null,
  timePeriodEnd:    null,
  timePeriodLength: null,
  geoIds:           null,
  regionsToPlot:    null
};

export default IndicatorEvolutionContainer;



// WEBPACK FOOTER //
// ./src/modules/Content/IndicatorEvolutionContainer/IndicatorEvolutionContainer.jsx